<template>
  <b-container class="footer-tab">
    <b-row class="footer-contain">
      <b-col md="12" sm="6">
        <img id="footer-logo" v-lazy="require(`@/assets/ftcash-color.png`)" alt="ftcash footer logo" />
      </b-col>
    </b-row>
    <b-row id="footer-content">
      <b-col md="3" sm="4" id="col-one">
        <div id="payments">
          <h4 id="footer-payments" class="footer-heading">Payments</h4>
          <h6 id="footer-pno" class="footer-text">+91 983 349 6939</h6>
          <h6 id="footer-pid" class="footer-text">
            <a href="mailto:support@ftcash.com" class="link text-decoration-none">support@ftcash.com</a>
          </h6>
        </div>
        <div id="loans">
          <h4 id="footer-loan" class="footer-heading">Loans</h4>
          <h6 id="footer-lno" class="footer-text">+91 829 101 0706</h6>
          <h6 id="footer-lid" class="footer-text">loans@ftcash.com</h6>
         <!-- <a href="https://www.ftcash.com/app/loan/index" target="_blank" rel=”noreferrer” class="footer-links link text-decoration-none" id="footer-applyloan"> <h6
            id="footer-applyloan link text-decoration-none"
            class="footer-links"
            @click="applyLink()"
          >Apply for Loan</h6></a> -->
        </div>
        <div id="Grievance">
            <h2 class="footer-text">
              <router-link to="grievence" @click.native="redirectToExternalLink()" class="link text-decoration-none badge badge-light" style="font-size: 1em; padding: 0.5em 1em;">Click To Register Grievence</router-link>
            </h2>
        </div>
      </b-col>
      <b-col md="3" sm="4" id="col-two">
        <h4 id="footer-company" class="footer-heading">Company</h4>
        <h6 id="footer-about" class="footer-text">
          <router-link to="/about" class="link text-decoration-none">About Us</router-link>
        </h6>
        <h6 id="footer-team" class="footer-text">
          <router-link to="/awards" class="link text-decoration-none">Media And Awards</router-link>
        </h6>
        <h6 id="footer-contact" class="footer-text">
          <router-link to="/contact" class="link text-decoration-none">Contact Us</router-link>
        </h6>
        <div id="nodal">
          <h4 id="footer-nodal" class="footer-heading">Nodal Officer</h4>
          <h4 id="footer-nname" class="footer-text">Mr. Deepak Kothari</h4>
          <h6 id="footer-npno" class="footer-text">+91 983 349 6939</h6>
          <h6 id="footer-pid" class="footer-text">
          <a href="mailto:deepak@ftcash.com" class="link text-decoration-none">deepak@ftcash.com</a>
          </h6>
          <h6 id="footer-nodal-address" class="footer-text">
          <a>Times Square, Tower C, 3rd Floor, Marol Andheri East Mumbai-400059</a>
          </h6>
        </div>
      </b-col>
      <b-col md="3" sm="4" id="col-three">
        <h4 id="footer-resources" class="footer-heading">Resources</h4>
        <!-- <h6 id="footer-faqs" class="footer-text">
          <router-link to="/faq" class="link text-decoration-none">FAQs</router-link>
        </h6> -->
        <h6 id="footer-tnc" class="footer-text">
          <router-link to="/tnc" class="link text-decoration-none">Terms and Conditions</router-link>
        </h6>
        <!-- <h6 id="footer-refertnc" class="footer-text">
          <a href="https://play.google.com/store/apps/details?id=com.ftcash.app.android.refer" rel=”noreferrer” target="_blank" class="link text-decoration-none">Merchant Referral</a>
        </h6> -->
        <h6 id="footer-privacy" class="footer-text">
          <router-link to="/privacypolicy" class="link text-decoration-none">Privacy Policy</router-link>
        </h6>
      </b-col>
      <b-col md="2" sm="12" id="col-five">
        <div id="get-app">
          <h4 id="footer-getapp" class="footer-heading">Get the app</h4>
          <img
            class="getit"
            @click="googleplayLink()"
            v-lazy="require(`@/assets/img/googleplay.png`)"
            alt="footer-android"
          />
          <img
            class="getit mb-5"
            @click="appstoreLink()"
            v-lazy="require(`@/assets/img/appstore.png`)"
            alt="footer-iOS"
          />
        </div>
      </b-col>
    </b-row>

    <b-row id="mobile-footer-content">
      <b-col cols="6" id="mcol-one">
        <div id="mloans">
          <h4 id="mfooter-loan" class="footer-heading">Loans</h4>
          <h6 id="mfooter-lno" class="footer-text">+91 829 101 0706</h6>
          <h6 id="mfooter-lid" class="footer-text">loans@ftcash.com</h6>
          <!-- <h6
            id="mfooter-applyloan link text-decoration-none"
            class="footer-links"
            @click="applyLink()"
          >Apply for Loan</h6> -->
        </div>

        <h4 id="mfooter-company" class="footer-heading">Company</h4>
        <h6 id="mfooter-about" class="footer-text">
          <router-link to="/about" class="link text-decoration-none">About Us</router-link>
        </h6>
        <h6 id="mfooter-team" class="footer-text">
          <router-link to="/awards" class="link text-decoration-none">Media And Awards</router-link>
        </h6>
        <h6 id="mfooter-contact" class="footer-text">
          <router-link to="/contact" class="link text-decoration-none">Contact Us</router-link>
        </h6>
        <div id="mnodal">
          <h4 id="mfooter-nodal" class="footer-heading">Nodal Officer</h4>
          <h4 id="mfooter-nname" class="footer-text">Mr. Deepak Kothari</h4>
          <h6 id="mfooter-nno" class="footer-text">+91 983 349 6939</h6>
          <h6 id="mfooter-nid" class="footer-text">
          <a href="mailto:deepak@ftcash.com" class="link text-decoration-none">deepak@ftcash.com</a>
          </h6>
          <h6 id="mfooter-nodal-address" class="footer-text">
          <a>Times Square, Tower C, 3rd Floor, Marol Andheri East Mumbai-400059</a>
          </h6>
        </div>
        <div id="mpayments">
          <h4 id="mfooter-payments" class="footer-heading">Payments</h4>
          <h6 id="mfooter-pno" class="footer-text">+91 983 349 6939</h6>
          <h6 id="m-pid" class="footer-text">
            <a href="mailto:support@ftcash.com" class="link text-decoration-none">support@ftcash.com</a>
          </h6>
        </div>
      </b-col>
      <b-col cols="6" id="mcol-two">
        <h4 id="mfooter-resources" class="footer-heading">Resources</h4>
        <!-- <h6 id="mfooter-faqs" class="footer-text">
          <router-link to="/faq" class="link text-decoration-none">FAQs</router-link>
        </h6> -->
        <h6 id="mfooter-tnc" class="footer-text">
          <router-link to="/tnc" class="link text-decoration-none">Terms and Conditions</router-link>
        </h6>
        <!-- <h6 id="mfooter-refertnc" class="footer-text">
          <a href="https://play.google.com/store/apps/details?id=com.ftcash.app.android.refer" rel=”noreferrer” target="_blank" class="link text-decoration-none">Merchant Referral</a>
        </h6> -->
        <h6 id="mfooter-privacy" class="footer-text">
          <router-link to="/privacypolicy" class="link text-decoration-none">Privacy Policy</router-link>
        </h6>

        <h4 id="footer-getapp" class="footer-heading">Get the app</h4>
        <img
          class="mgetit"
          @click="googleplayLink()"
          v-lazy="require(`@/assets/img/googleplay.png`)"
          alt="footer-android"
        />
        <img
          class="mgetit mb-3"
          @click="appstoreLink()"
          v-lazy="require(`@/assets/img/appstore.png`)"
          alt="footer-iOS"
        />

        <!-- <h4 id="footer-location" class="footer-heading float-left"><a href="https://goo.gl/maps/F9hmQZYcE86Lxtp38" target="_blank" class="link text-decoration-none">
            <img src="../../assets/img/marker.svg" alt="ftcash Location"> Our Location</a>
        </h4>-->
      </b-col>
    </b-row>
    <b-row id="footer-logos-bottom" class="justify-content-center">
      <b-col id="footer-pci-dss">
        <a
          href="http://seal.panaceainfosec.com/index.php?certid=CERT87F235E644"
          onclick="window.open(this.href,'Panacea Certificate','height=100,width=150,scrollbar=yes,status=no,menubar=no,toolbar=no,resizable'); return false"
          class="panacea"
        >
          <img
            class="foot-bottom-tu mb-1"
            v-lazy="require(`@/assets/logos/panacea.png`)"
            alt="panacea logo"
          />
        </a>
        <a
          href="https://www.cibil.com/official-partners"
          onclick="window.open(this.href,'Tranunion Partners','height=100,width=150,scrollbar=yes,status=no,menubar=no,toolbar=no,resizable'); return false"
          class="panacea"
        >
        <img
          class="foot-bottom-tu mb-1"
          v-lazy="require(`@/assets/logos/transunion.jpg`)"
          alt="transunion logo"
        />
        </a>
      </b-col>
    </b-row>
    <b-row id="office-address-div" class="justify-content-center">
      <b-col md="12" sm="12">
        <p class="follow-us-text">Follow us on:</p>
      </b-col>
      <b-col md="5" sm="12" id="social" class="text-center">
        <a href="https://www.facebook.com/ftcashapp/" class="link text-decoration-none">
          <img id="ftcash-fb" class="pr-2" v-lazy="require(`@/assets/img/facebook.png`)" alt="Facebook logo" />
        </a>
        <a href="https://www.instagram.com/ftcashapp/?hl=en" class="link text-decoration-none">
          <img id="ftcash-insta" class="pr-2" v-lazy="require(`@/assets/img/insta.png`)" alt="Instagram logo" />
        </a>
        <a href="https://twitter.com/ftcashapp?lang=en" class="link text-decoration-none">
          <img id="ftcash-tweet" class="pr-2" v-lazy="require(`@/assets/img/tweeter.png`)" alt="Twitter logo" />
        </a>
        <a href="https://in.linkedin.com/company/ftcash" class="link text-decoration-none">
          <img
            id="ftcash-linkedin"
            class="pr-2"
            v-lazy="require(`@/assets/img/linkedin.png`)"
            alt="Linkedin logo"
          />
        </a>
        <a
          href="https://www.youtube.com/channel/UC1eS2OoLoiROIKXo2d4JCaQ"
          class="link text-decoration-none"
        >
          <img
            id="ftcash-youtube"
            class="pr-2"
            v-lazy="require(`@/assets/img/youtube.png`)"
            alt="ftcash logo"
          />
        </a>
      </b-col>
      <b-col md="12" sm="12" id="copyright">
        <!--<p class="footer-address-line">Address: 1001, Lodha Supremus, Saki Vihar Road, Powai, Mumbai - 400 072, India.</p> -->
        <p class="footer-contact-line">
          Contact: +91 983 349 6939 |
          <a href="mailto:support@ftcash.com" class="link text-decoration-none">support@ftcash.com</a>
        </p>
        <p class="footer-copyright-line">Copyright &copy; 2020 Nomisma Mobile Solutions Pvt. Ltd. All rights reserved.</p>
      </b-col>
    </b-row>
    
  </b-container>
  <!--</footer>-->
</template>

<script>
export default {
  name: "Footers",
  data() {
    return {
      support: "support@ftcash.com",
      //   intersectionOptions: {
      //     root: null,
      //     rootMargin: '0px 0px 0px 0px',
      //     threshold: 0.25 // [0.25, 0.75] if you want a 25% offset!
      // },
    };
  },
  methods: {
    //  scrollToCd({going, direction}) {
    //             if (direction === this.$waypointMap.DIRECTION_TOP && going === 'in') {
    //                 let elem = this.$refs.cd
    //                 const options = {
    //                     easing: 'ease',
    //                     offset: 20,
    //                     force: true,
    //                     x: false,
    //                     y: true
    //                 }
    //                  this.$scrollTo(elem, 1000, options)
    //             }
    //         },
    applyLink() {
      // window.location.href = ("https://www.ftcash.com/app/loan/index", '_blank');
      window.open("https://www.ftcash.com/app/loan/index", "_blank");
    },
    googleplayLink() {
      window.open(
        "https://play.google.com/store/apps/details?id=com.ftcash.customer",
        "_blank"
      );
    },
    appstoreLink() {
      window.open("https://apps.apple.com/in/app/ftcash/id998463502", "_blank");
    },
    redirectToExternalLink() {
            window.open("https://ftcash.com/app/grievence", "_blank");
    },
  },
};
</script>
<style scoped>
.link {
  color: var(--mainBlueColor);
}
.foot-bottom-pci {
  width: 7%;
}
.foot-bottom-tu {
  width: 50px;
  margin: 0 0.5rem 1rem 0.5rem;
}
.footer-contain {
  justify-content: center;
}
.footer-heading {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--mainBlueColor);
  text-align: left;
  margin-bottom: 0.5rem;
}
.footer-text {
  font-size: 0.9rem;
  color: var(--mainBlueColor);
  text-align: left;
}
.footer-links {
  color: var(--mainBlueColor);
  text-decoration: underline;
  font-weight: 700;
  font-size: 0.9rem;
  text-align: left;
}
.getit {
  float: right;
  width: 100%;
  margin-bottom: 1rem;
  box-shadow: 0px 0px 4px #d0d0d0;
  border-radius: 8px;
  cursor: pointer;
}
.footer-tab {
  padding-top: 60px;
}

.footer-contact-line{
  margin-bottom:0.5rem;
}
.footer-address-line{
  margin-bottom:0.5rem;
}
.footer-copyright-line{
  margin-bottom:0.5rem;
  font-size: 14px;
}
.follow-us-text{
  margin-bottom:0.5rem;
}

#email,
#payments,
#nodal,
#loans {
  margin-bottom: 2rem;
}
#footer-email,
#footer-payments,
#footer-loan,
#footer-pno,
#footer-pid,
#footer-lno,
#footer-lid {
  margin-bottom: 0.5rem;
}
#mobile-footer-content {
  display: none;
}
#memail,
#mnodal,
#mpayments,
#mloans {
  margin-bottom: 2rem;
}
#mfooter-email,
#mfooter-payments,
#mfooter-loan,
#mfooter-pno,
#mfooter-pid,
#mfooter-lno,
#mfooter-lid {
  margin-bottom: 0.5rem;
}
#mfooter-company,
#mfooter-resources,
#mfooter-legal,
#mfooter-privacy,
#mfooter-getapp,
#mfooter-about,
#mfooter-team,
#mfooter-careers,
#mfooter-blog,
#mfooter-contact,
#mfooter-calculator,
#mfooter-app,
#mfooter-faqs,
#mfooter-tnc,
#mfooter-refertnc,
#mfooter-company,
#mfooter-about,
#mfooter-team,
#mfooter-careers,
#mfooter-blog,
#mfooter-contact,
#mfooter-nodal,
#mfooter-,
#mfooter-nno,
#mfooter-nid,
#mfooter-nodal-address,
#mfooter-location {
  margin-bottom: 1rem;
}
#footer-logo {
  float: left;
  width: 8rem;
  margin: 0 0 2.5rem 0;
}
#support {
  bottom: 25px;
}
#office-address > div {
  margin-top: 500px;
  text-align: center;
}
#office-address-div {
  padding-top: 0.6rem;
  color: var(--mainBlueColor);
  font-weight: bold;
  text-align: center;
}
#footer-company,
#footer-resources,
#footer-legal,
#footer-privacy,
#footer-getapp,
#footer-about,
#footer-team,
#footer-careers,
#footer-blog,
#footer-contact,
#footer-calculator,
#footer-app,
#footer-faqs,
#footer-tnc,
#footer-refertnc,
#footer-company,
#footer-about,
#footer-team,
#footer-careers,
#footer-blog,
#footer-contact,
#footer-nodal,
#footer-,
#footer-nno,
#footer-nid,
#footer-nodal-address,
#footer-location {
  margin-bottom: 1.5rem;
}
#col-three,
#col-four {
  margin-left: 1rem;
  margin-right: 1rem;
}
#col-five {
  margin-left: 1rem;
}
#ftcash-fb,
#ftcash-insta,
#ftcash-tweet,
#ftcash-linkedin,
#ftcash-youtube {
  width: 7%;
}
#social {
  margin-bottom: 0.7rem;
}

@media (min-width: 1025px) and (max-width: 1280px) {
  #footer-logo {
    margin-left: auto;
    margin-right: auto;
    width: 160px;
    margin-top: 1rem;
    margin-bottom: 1rem;
    text-align: center;
  }
  .getit {
    width: 100%;
    float: none;
  }
  #footer-company,
  #footer-about,
  #footer-team,
  #footer-careers,
  #footer-blog,
  #footer-contact,
  #footer-resources,
  #footer-calculator,
  #footer-app,
  #footer-faqs,
  #footer-legal,
  #footer-tnc,
  #footer-refertnc,
  #footer-privacy,
  #footer-getapp,
  #footer-company,
  #footer-about,
  #footer-team,
  #footer-careers,
  #footer-blog,
  #footer-contact,
  #footer-nodal,
  #footer-,
  #footer-nno,
  #footer-nid,
  #footer-nodal-address,
  #footer-location {
    margin-bottom: 0.75rem;
  }
  .footer-contain {
    margin-bottom: 1rem;
  }
}

@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  #footer-logo {
    width: 160px;
    margin: 1rem auto 1.5rem auto;
    text-align: center;
  }
  .getit {
    width: 100%;
    float: none;
  }
  #footer-company,
  #footer-about,
  #footer-team,
  #footer-careers,
  #footer-blog,
  #footer-contact,
  #footer-resources,
  #footer-calculator,
  #footer-app,
  /* #footer-faqs, */
  #footer-legal,
  #footer-tnc,
  #footer-refertnc,
  #footer-privacy,
  #footer-getapp,
  #footer-company,
  #footer-about,
  #footer-team,
  #footer-careers,
  #footer-blog,
  #footer-contact,
  #footer-nodal,
  #footer-,
  #footer-nno,
  #footer-nid,
  #footer-nodal-address,
  #footer-location {
    margin-bottom: 0.75rem;
  }
  .footer-contain {
    margin-bottom: 1rem;
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  #footer-logo {
    width: 160px;
    margin: 1rem auto 1.5rem auto;
    text-align: center;
  }
  .getit {
    width: 100%;
    float: none;
  }
  #footer-company,
  #footer-about,
  #footer-team,
  #footer-careers,
  #footer-blog,
  #footer-contact,
  #footer-resources,
  #footer-calculator,
  #footer-app,
  /* #footer-faqs, */
  #footer-legal,
  #footer-tnc,
  #footer-refertnc,
  #footer-privacy,
  #footer-getapp,
  #footer-company,
  #footer-about,
  #footer-team,
  #footer-careers,
  #footer-blog,
  #footer-contact,
  #footer-nodal,
  #footer-,
  #footer-nno,
  #footer-nid,
  #footer-nodal-address,
  #footer-location {
    margin-bottom: 0.75rem;
  }
  .footer-contain {
    margin-bottom: 1rem;
  }
}

@media (min-width: 481px) and (max-width: 767px) {
  .footer-heading {
    font-size: 1.2rem;
    font-weight: 400;
    color: var(--mainBlueColor);
    text-decoration: underline;
  }
  #ftcash-fb,
  #ftcash-insta,
  #ftcash-tweet,
  #ftcash-linkedin,
  #ftcash-youtube {
    width: 7%;
  }
  .footer-text {
    font-size: 0.9rem;
    font-weight: 400;
    color: var(--mainBlueColor);
    text-align: left;
  }
  .footer-links {
    text-decoration: underline;
    font-weight: 400;
    font-size: 0.9rem;
    cursor: pointer;
    text-align: left;
  }
  .foot-bottom-pci {
    width: 50px;
  }
  .foot-bottom-tu {
    width: 50px;
    margin: 0 1rem 1rem 1rem;
  }
  #copyright {
    font-size: 0.8rem;
  }
  #footer-logo {
    margin-left: auto;
    margin-right: auto;
    width: 160px;
    margin-top: 1rem;
    margin-bottom: 1rem;
    text-align: center;
  }
  #mobile-footer-content {
    display: flex;
  }
  #footer-content {
    display: none;
  }
  .mgetit {
    width: 55%;
    float: left;
    margin-bottom: 0.4rem;
    border-radius: 5px;
    cursor: pointer;
  }
  #footer-company,
  #footer-about,
  #footer-team,
  #footer-careers,
  #footer-blog,
  #footer-contact,
  #footer-resources,
  #footer-calculator,
  #footer-app,
  /* #footer-faqs, */
  #footer-legal,
  #footer-tnc,
  #footer-refertnc,
  #footer-privacy,
  #footer-getapp,
  #footer-company,
  #footer-about,
  #footer-team,
  #footer-careers,
  #footer-blog,
  #footer-contact,
  #footer-nodal,
  #footer-,
  #footer-nno,
  #footer-nid,
  #footer-nodal-address,
  #footer-location {
    margin-bottom: 0.75rem;
  }
  .footer-contain {
    margin-bottom: 1rem;
    justify-content: left;
  }
  .footer-copyright-line {
    margin-bottom: 0.5rem;
    font-size: 10px;
}
}
@media (max-width: 480px) {
  .footer {
    position: absolute;
    height: 100vh;
    width: 100%;
    background: white;
    left: 0%;
    padding: 10px;
  }
  .footer-heading {
    font-size: 0.9rem;
    font-weight: 400;
    color: var(--mainBlueColor);
    text-decoration: underline;
  }
  .foot-bottom-pci {
    width: 50px;
  }
  .foot-bottom-tu {
    width: 50px;
    margin: 0 0.5rem 1rem 0.5rem;
  }
  #ftcash-fb,
  #ftcash-insta,
  #ftcash-tweet,
  #ftcash-linkedin,
  #ftcash-youtube {
    width: 8%;
  }
  .footer-text {
    font-size: 0.7rem;
    font-weight: 400;
    color: var(--mainBlueColor);
    text-align: left;
  }
  .footer-links {
    text-decoration: underline;
    font-weight: 400;
    font-size: 0.7rem;
    cursor: pointer;
    text-align: left;
  }
  #copyright {
    font-size: 0.8rem;
  }
  #col-one {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    float: left;
  }
  #col-two,
  #col-three,
  #col-four {
    margin: 0 0.5rem 0.5rem 0.5rem;
    float: right;
  }
  #col-two {
    margin-bottom: 1.25rem;
  }
  #col-five {
    border-top: 1px solid rgba(42, 75, 124, 0.45);
    padding-top: 1rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
  #col-five .footer-heading {
    text-align: center;
  }
  #footer-logo {
    margin-left: auto;
    margin-right: auto;
    width: 35%;
    margin-top: 1rem;
    margin-bottom: 1rem;
    text-align: center;
  }
  #mobile-footer-content {
    display: flex;
  }
  #footer-content {
    display: none;
  }
  .getit {
    width: 52%;
    float: none;
  }
  .mgetit {
    width: 65%;
    float: left;
    margin-bottom: 0.4rem;
    border-radius: 5px;
    cursor: pointer;
  }
  #footer-company,
  #footer-about,
  #footer-team,
  #footer-careers,
  #footer-blog,
  #footer-contact,
  #footer-resources,
  #footer-calculator,
  #footer-app,
  /* #footer-faqs, */
  #footer-legal,
  #footer-tnc,
  #footer-refertnc,
  #footer-privacy,
  #footer-getapp,
  #footer-company,
  #footer-about,
  #footer-team,
  #footer-careers,
  #footer-blog,
  #footer-contact,
  #footer-nodal,
  #footer-,
  #footer-nno,
  #footer-nid,
  #grievence,
  #footer-nodal-address,
  #footer-location {
    margin-bottom: 0.75rem;
  }
  .footer-contain {
    margin-bottom: 1rem;
  }
  .footer-copyright-line {
   
    font-size: 10px;
}
}
</style>
